export default __webpack_public_path__ + "static/media/bonuses.576ba86f.svg";